import {getDocs, collection} from 'firebase/firestore';
import {database} from '../firebase';
import {Brand} from '@/types';

let cachedBrands: Brand[] = [];

export const getBrands = async (forceRefresh = false): Promise<Brand[]> => {
    if (!forceRefresh && cachedBrands.length > 0) {
        return cachedBrands;
    }

    if (!forceRefresh) {
        const stored = localStorage.getItem('cachedBrands');
        if (stored) {
            cachedBrands = JSON.parse(stored) as Brand[];
            return cachedBrands;
        }
    }

    try {
        const brandsCollection = collection(database, 'brands');
        const brandsSnapshot = await getDocs(brandsCollection);

        if (brandsSnapshot.empty) {
            console.warn('No se encontraron marcas.');
            cachedBrands = [];
        } else {
            cachedBrands = brandsSnapshot.docs.map(doc => ({
                ...doc.data(),
                id: doc.id,
            } as Brand));
            localStorage.setItem('cachedBrands', JSON.stringify(cachedBrands));
        }
        return cachedBrands;
    } catch (error) {
        console.error('Error al obtener las marcas:', error);
        return [];
    }
}
